/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_In_Desktop_LaunchingInputs */



/**
* | output |
* | --- |
* | "Launching the desktop app…" |
*
* @param {Open_In_Desktop_LaunchingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_in_desktop_launching = /** @type {((inputs?: Open_In_Desktop_LaunchingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_In_Desktop_LaunchingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lancement de l'application de bureau…")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Desktop-App wird gestartet…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio dell'applicazione desktop…")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запуск настольного приложения…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando la aplicación de escritorio…")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在启动桌面应用程序……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デスクトップアプリを起動しています…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डेस्कटॉप ऐप लॉन्च हो रहा है…")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando o aplicativo para desktop…")
	return /** @type {LocalizedString} */ ("Launching the desktop app…")
});